import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import data from './data/siteData.json';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import WhatsAppButton from './components/WhatsAppButton';
import Home from './pages/Home';
import Gallery from './pages/Gallery';
import Products from './pages/Products';
import Contact from './pages/Contact';
import Demo from './pages/Demo';

function App() {
  useEffect(() => {
    // Always set dark mode
    document.body.dataset.theme = 'dark';
    localStorage.setItem('lifttech-theme', 'dark');
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="page">
        <Navbar
          brand={data.brand}
          links={data.navLinks}
          cta={data.navCta}
        />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/products" element={<Products />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/cart" element={<Demo />} />
        </Routes>
        <Footer data={data.footer} />
        <WhatsAppButton />
      </div>
    </Router>
  );
}

export default App;
